import { render, staticRenderFns } from "./uploadFileSpecification.vue?vue&type=template&id=50b46182&scoped=true&"
import script from "./uploadFileSpecification.vue?vue&type=script&lang=js&"
export * from "./uploadFileSpecification.vue?vue&type=script&lang=js&"
import style0 from "./uploadFileSpecification.vue?vue&type=style&index=0&id=50b46182&prod&lang=css&"
import style1 from "./uploadFileSpecification.vue?vue&type=style&index=1&id=50b46182&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b46182",
  null
  
)

export default component.exports